export { default as BaseSlider } from './BaseSlider';
